<template>
  <div class="search-form px-2">
    <div class="col-sm-12 search-form-title">
      <font-awesome-icon icon="search" />
      {{ $t('common.search') }}
    </div>
    <div class="row">
      <div class="col-sm-6">
          <select
            id="types"
            class="form-select form-select-sm"
            v-model="type"
          >
              <option
                :value="null"
              >
                {{ $t('work_permission.select_type') }}
              </option>
            <option
              v-for="option in getTypes()"
              :key="option.value"
              :value="option.value"
            >
              {{ option.name }}
            </option>
          </select>
      </div>
      <div class="col-sm-6">
          <select
            id="statuses"
            v-model="status"
            class="form-select form-select-sm"
          >
              <option
                :value="null"
              >
                {{ $t('work_permission.select_status') }}
              </option>
            <option
              v-for="option in getStatus()"
              :key="option.value"
              :value="option.value"
            >
              {{ option.name }}
            </option>
          </select>
      </div>
    </div>
    <div class="col-sm-12 button-container">
      <button
        type="submit"
        class="btn btn-primary form-button"
        @click.stop="emitSearch"
      >
        {{ $t('ins_report.search') }}
      </button>
    </div>
  </div>
</template>

<script>
import {workPermissionHelper} from '../mixins/WorkPermissionMixin'

export default {
    name: 'WorkPermissionSearch',
    mixins: [workPermissionHelper],
    data: function () {
        return {
            type: null,
            status: null
        }
    },
    methods: {
        emitSearch: function () {
            this.$emit('search', {type: this.type, status: this.status})
        }
    }
}
</script>
